module.exports = __webpack_public_path__ + "static/media/145-ukraine.05bc6af9.svg";